export default {
  content: `<p>
    <span style="color: #548DD4;">中国的算力发展已形成以“智能算力为主导、全国一体化算力网为核心”的万亿级产业格局</span>。 依托“东数西算”战略，中国正通过算力与电力的深度协同，将算力打造成像“水电”一样即开即用的公共基础设施。
</p>
<p>
    <span style="font-size: 18px;"><strong>算力发展现状</strong></span>
</p>
<ul class=" list-paddingleft-2" style="list-style-type: disc;">
    <li>
        <p>
            智算规模爆发式增长：截至2026年3月底，中国已建成的智能算力规模达到188.2万P（等效1882 EFLOPS），同比实现2.5倍的跨越式增长，智能算力成为绝对增量主体。
        </p>
    </li>
    <li>
        <p>
            “8+10+3”空间布局成型：以8大国家算力枢纽、10个国家数据中心集群、3个算电协同发展区域为重点的空间结构彻底确立，实现了全国算力资源的集约化、规模化发展。
        </p>
    </li>
    <li>
        <p>
            “20毫秒时延圈”打通：枢纽间建成145条干线光缆，全国各省份至8大枢纽的网络传输时延全部降至20毫秒以内，“千里之外、瞬间即达”的算网融合成为现实。
        </p>
    </li>
    <li>
        <p>
            应用由“训”转“推”并加速下沉：随着大模型全面落地，智算中心正从大模型“训练”主导切换为“推理”主导，算力正深度赋能工业、交通、政务等千行百业。
        </p>
    </li>
    <li>
        <p>
            核心现实挑战：算力供给存在结构性错配，部分西部节点因实体基础薄弱面临“建而不用、利用率低”的隐忧，而东部的高端、高可靠性算力依然紧张。同时，高端AI芯片的自主创新仍有突围空间。
        </p>
    </li>
</ul>
<p>
    <br/>
</p>`,
};
